import React from 'react'
import { SettingContainer as SettingContainerWrapper } from './styled'

const SettingContainer = ({ children, id, tooltipId }) => {
  const getRemainingWidthOnRight = (element) => {
    if (!element) {
      return 0
    }

    const rect = element.getBoundingClientRect()
    const viewportWidth =
      window.innerWidth || document.documentElement.clientWidth

    const remainingWidth = viewportWidth - rect.right

    return remainingWidth
  }

  const handleMouseOver = (e) => {
    const showPopover = e.currentTarget.querySelector('.popover')
    if (showPopover) {
      showPopover.style.display = 'flex'
      const remainingRight = getRemainingWidthOnRight(e.currentTarget)
      const popoverWidth = showPopover.getBoundingClientRect().width
      if (remainingRight < popoverWidth) {
        const rightPadding = 50
        const overflowAmount = popoverWidth - remainingRight
        showPopover.style.left = `${-(overflowAmount + rightPadding)}px`
      } else {
        showPopover.style.left = 'auto'
      }
    }
  }

  const handleMouseOut = (e) => {
    const showPopover = e.currentTarget.querySelector('.popover')
    if (showPopover) {
      showPopover.style.display = 'none'
    }
  }

  return (
    <SettingContainerWrapper
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      onFocusCapture={handleMouseOver}
      onBlurCapture={handleMouseOut}
      id={id}
      aria-describedby={tooltipId}
    >
      {children}
    </SettingContainerWrapper>
  )
}

export default SettingContainer
